import React from 'react';
import { TextBlock, RectShape } from '@thd-olt-component-react/loading-placeholder';
import { Col } from '@thd-olt-component-react/grid';
import styles from './placeholder.module.scss';

export const ListTilePlaceholder = () => {
  return (
    <div className={styles.placeholder}>
      <div className={styles['placeholder__preview-thumbnails']}>
        <Col fallback={4}><RectShape color="#E0E0E0" style={{ height: '90px' }} /></Col>
        <Col fallback={4}><RectShape color="#E0E0E0" style={{ height: '90px' }} /></Col>
        <Col fallback={4}><RectShape color="#E0E0E0" style={{ height: '90px' }} /></Col>
      </div>
      <div className={styles['placeholder__list-name']}>
        <TextBlock rows={2} color="#E0E0E0" />
      </div>
    </div>
  );
};

ListTilePlaceholder.displayName = 'ListTilePlaceholder';
